import "./DatasetScoring.scss";

import {
  CCard,
  CCardHeader,
  CCol,
  CCollapse,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CLink,
  CButton,
  CAlert,
} from "@coreui/react";
import { AssociateDatasetButton } from "../models/ModelButtons";
import CIcon from "@coreui/icons-react";
import { MapDataSetFieldsForm } from "../models/Models";
import UploadToDataset from "../datasets/UploadToDataset";
import { ModelVersionSelector } from "../datasets/DatasetModelStats";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedModelVersion } from "./DatasetScoringSlice";

export default function Step(props) {
  const [collapsed, setCollapsed] = useState(props.collapsed);
  useEffect(() => {
    if (
      props.successProgress > props.step_number &&
      !(props.step_number === 3 && props.successProgress === 4)
    ) {
      setCollapsed(true);
    } else {
      if (
        props.successProgress === props.step_number ||
        (props.step_number === 3 && props.successProgress === 4)
      ) {
        setCollapsed(false);
      }
    }
  }, [props.successProgress]);

  return (
    <>
      <CCard data-testid={props.testId} style={{ margin: "1em" }}>
        <CCardHeader>
          <a
            style={{
              display: "block",
              position: "relative",
              top: "-60px",
              visibility: "hidden",
            }}
          />
          <div
            style={{
              display: "flex",
            }}
          >
            <CLink
              className="card-header-action"
              style={{ marginRight: "25px", flexGrow: 0 }}
              onClick={() => {
                if (!props.canCollapsed) {
                  setCollapsed((state) => !state);
                }
              }}
            >
              <CIcon
                name={collapsed ? "cil-chevron-bottom" : "cil-chevron-top"}
              />
            </CLink>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexBasis: "100%",
              }}
            >
              <h2
                id={`model-name-header`}
                style={{
                  color: props.canCollapsed ? "gray" : "",
                }}
              >
                {props.name}
              </h2>
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  flex: "1",
                  marginRight: "20px",
                  marginLeft: "40px",
                  overflowWrap: "anywhere",
                }}
              >
                {props.ifCheckedStep && (
                  <input
                    type="checkbox"
                    name="switch"
                    className="check"
                    defaultChecked={true}
                    disabled={true}
                  />
                )}
              </div>
            </div>
          </div>
        </CCardHeader>
        {!collapsed && (
          <CCollapse show={!props.canCollapsed}>
            <div className="data-scoring">
              <>{props.children}</>
            </div>
          </CCollapse>
        )}
      </CCard>
    </>
  );
}

Step.propTypes = {
  name: PropTypes.string,
  step_number: PropTypes.number,
  successProgress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ifCheckedStep: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  collapsed: PropTypes.bool,
  canCollapsed: PropTypes.bool,
  step_description: PropTypes.string,
  testId: PropTypes.string,
};

export const DataSelectStep = (props) => {
  return (
    <Step {...props}>
      <div style={{ display: "flex" }}>
        <div style={{ maxWidth: "500px", width: "100%" }}>
          <span className="data-scoring__title">Select Dataset</span>
          <CCol sm={8} className="data-scoring__dropdown-dataset">
            <CDropdown>
              <CDropdownToggle
                data-testid="ds-scoring-dropdown-dataset"
                color="primary"
                style={{ width: "100%", overflowX: "clip" }}
              >
                {props.dataset.name.length < 1 ? "Select" : props.dataset.name}
              </CDropdownToggle>
              <CDropdownMenu
                style={{
                  width: "100%",
                  maxHeight: "300px",
                  overflowY: "scroll",
                }}
              >
                {props.datasetList ? (
                  [
                    { id: 9999, name: "Create new..." },
                    ...props.datasetList,
                  ].map((datasetItem, index) => {
                    return (
                      <CDropdownItem
                        key={index}
                        onClick={() => {
                          props.onChangeDataset({
                            name: datasetItem.name,
                            id: datasetItem.id,
                          });
                        }}
                      >
                        {datasetItem.name}
                      </CDropdownItem>
                    );
                  })
                ) : (
                  <CDropdownItem>Select</CDropdownItem>
                )}
              </CDropdownMenu>
            </CDropdown>
          </CCol>
          {props.sourceDataRecords &&
            props.sourceDataRecords.pages[0].length < 1 &&
            props.dataset &&
            props.dataset.name.length > 0 &&
            props.isVisibleUpload && (
              <>
                <span className="data-scoring__title">Upload File</span>
                <CCol sm={8} className="data-scoring__dropdown-dataset">
                  <UploadToDataset
                    datasetId={props.dataset.id}
                    titleHide={true}
                    onDoneClick={props.setIsVisibleUpload}
                    doneCallback={() => props.setSourceData(props.dataset.id)}
                  />
                </CCol>
              </>
            )}
        </div>
        <StepText>{props.step_description}</StepText>
      </div>
    </Step>
  );
};

DataSelectStep.propTypes = {
  dataset: PropTypes.object,
  datasetList: PropTypes.array,
  onChangeDataset: PropTypes.func,
  sourceDataRecords: PropTypes.object,
  name: PropTypes.string,
  step_number: PropTypes.number,
  successProgress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ifCheckedStep: PropTypes.bool,
  step_description: PropTypes.string,
  isVisibleUpload: PropTypes.bool,
  setIsVisibleUpload: PropTypes.func,
  setSourceData: PropTypes.func,
};

export const DataScoringStep = (props) => {
  const filteredModelList =
    (props.modelList &&
      props.modelList.filter(
        (item) =>
          item.versions.filter((version) => version.is_deployed).length > 0,
      )) ||
    [];

  return (
    <Step {...props}>
      <div style={{ display: "flex" }}>
        <div style={{ maxWidth: "500px", width: "100%" }}>
          <span className="data-scoring__title">Select Model</span>
          <CCol sm={8} className="data-scoring__dropdown-dataset">
            <CDropdown>
              <CDropdownToggle
                data-testid="ds-scoring-dropdown-model"
                color="primary"
                style={{ width: "100%", overflowX: "clip" }}
              >
                {props.modelCur || "Select"}
              </CDropdownToggle>
              <CDropdownMenu
                style={{
                  width: "100%",
                  maxHeight: "300px",
                  overflowY: "scroll",
                }}
              >
                {filteredModelList ? (
                  filteredModelList.map((modelItem, index) => {
                    return (
                      <CDropdownItem
                        key={index}
                        onClick={() => {
                          props.onChangeModel(modelItem.name);
                          props.onChangeModelVersion(modelItem.versions);
                          // props.onChangeCurrentModelVersion(1);
                        }}
                      >
                        {modelItem.name}
                      </CDropdownItem>
                    );
                  })
                ) : (
                  <CDropdownItem>Select</CDropdownItem>
                )}
              </CDropdownMenu>
            </CDropdown>
          </CCol>
          <span className="data-scoring__title">Select Version</span>
          <CCol sm={8} className="data-scoring__dropdown-dataset">
            <CCol
              sm={8}
              className="data-scoring__dropdown-dataset"
              style={{ padding: "0px" }}
            >
              <CDropdown>
                <CDropdownToggle
                  data-testid="ds-scoring-dropdown-version"
                  color="primary"
                  style={{
                    width: "100%",
                    overflowX: "clip",
                    padding: "7px 15px",
                  }}
                  disabled={!props.modelCur}
                >
                  {props.currentModelVersion === 0
                    ? "Select"
                    : "Version: " + props.currentModelVersion}
                </CDropdownToggle>
                <CDropdownMenu
                  style={{
                    width: "100%",
                    maxHeight: "300px",
                    overflowY: "scroll",
                  }}
                >
                  {props.modelVersion ? (
                    props.modelVersion.map((versionItem, index) => {
                      if (versionItem.is_deployed) {
                        return (
                          <CDropdownItem
                            key={index}
                            onClick={() => {
                              props.onChangeCurrentModelVersion(index + 1);
                              props.handleSubmit(
                                props.modelList.filter(
                                  (models) => models.name === props.modelCur,
                                )[0]?.id || 1,
                                props.dataset.id,
                              );
                            }}
                          >
                            <>
                              {index + 1} (
                              {versionItem.is_deployed
                                ? "deployed"
                                : "not deployed"}
                              )
                            </>
                          </CDropdownItem>
                        );
                      }
                    })
                  ) : (
                    <CDropdownItem>Select</CDropdownItem>
                  )}
                </CDropdownMenu>
              </CDropdown>
            </CCol>
          </CCol>
        </div>
        <StepText>{props.step_description}</StepText>
      </div>
    </Step>
  );
};

DataScoringStep.propTypes = {
  modelCur: PropTypes.string,
  modelList: PropTypes.array,
  onChangeModelVersion: PropTypes.func,
  onChangeModel: PropTypes.func,
  onChangeCurrentModelVersion: PropTypes.func,
  currentModelVersion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  modelVersion: PropTypes.array,
  handleSubmit: PropTypes.func,
  name: PropTypes.string,
  step_number: PropTypes.number,
  successProgress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ifCheckedStep: PropTypes.bool,
  step_description: PropTypes.string,
  dataset: PropTypes.object,
};

export const MapDatasetStep = (props) => {
  return (
    <Step {...props}>
      <div style={{ display: "flex" }}>
        <div style={{ maxWidth: "500px", width: "100%" }}>
          <span className="data-scoring__title">Map Associated Dataset</span>
          <CCol
            sm={8}
            className="data-scoring__dropdown-dataset"
            data-testid="ds-scoring-btn-map"
          >
            <AssociateDatasetButton
              color="primary"
              executecontents="Map Associated Dataset"
              modaltitle="Map Associated Dataset"
            >
              <MapDataSetFieldsForm
                model_id={
                  props.modelList
                    ? props.modelList.filter(
                        (models) => models.name === props.modelCur,
                      )[0]?.id
                    : 1
                }
                model_version_num={props.currentModelVersion}
                defaultDatasetId={props.dataset.id}
                setStatus={props.setMapStatus}
                disabled={true}
              />
            </AssociateDatasetButton>
          </CCol>
        </div>
        <StepText>{props.step_description}</StepText>
      </div>
    </Step>
  );
};

MapDatasetStep.propTypes = {
  modelList: PropTypes.array,
  modelCur: PropTypes.string,
  currentModelVersion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  step_number: PropTypes.number,
  successProgress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ifCheckedStep: PropTypes.bool,
  step_description: PropTypes.string,
  dataset: PropTypes.object,
  setMapStatus: PropTypes.func,
};

export const ScoreDatasetStep = (props) => {
  const alert = props.successProgress &&
    props.step_number &&
    props.successProgress > props.step_number && (
      <CAlert color="primary">Data scoring completed.</CAlert>
    );

  const dispatch = useDispatch();
  const modelId = props.modelVersion ? props.modelVersion.id : 0;
  return (
    <Step {...props}>
      <div style={{ display: "flex" }}>
        <div style={{ maxWidth: "500px", width: "100%" }}>
          <span className="data-scoring__title">Select Model and score</span>
          <CCol sm={8} className="data-scoring__dropdown-dataset">
            <ModelVersionSelector
              datasetId={props.dataset.id}
              modelVersionId={props.currentModelVersionScore}
              setSuccessScore={props.setSuccessScore}
              disabled={true}
              modelVersion={props.modelVersion}
            />
          </CCol>
          {alert}
          <Link to={`/datasets/${props.dataset.id}/stats`}>
            <CButton
              data-testid="ds-scoring-btn-analyze"
              color="success"
              className={"mb-1"}
              onClick={() => dispatch(setSelectedModelVersion(modelId))}
            >
              Analyze Dataset
            </CButton>
          </Link>
        </div>
        <StepText>{props.step_description}</StepText>
      </div>
    </Step>
  );
};

ScoreDatasetStep.propTypes = {
  dataset: PropTypes.object,
  currentModelVersionScore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setSuccessScore: PropTypes.func,
  name: PropTypes.string,
  step_number: PropTypes.number,
  successProgress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ifCheckedStep: PropTypes.bool,
  step_description: PropTypes.string,
  modelVersion: PropTypes.object,
};

const StepText = (props) => {
  return (
    <div
      style={{
        display: "flex",
        paddingLeft: "25px",
        paddingRight: "25px",
        alignItems: "center",
        width: "100%",
      }}
    >
      {props.children}
    </div>
  );
};

StepText.propTypes = {
  children: PropTypes.node.isRequired,
};
